import {createFileRoute} from '@tanstack/react-router';
import Chat from '@features/preview/[id]/page';

export const Route = createFileRoute('/preview/$id')({
  component: function PreviewPage() {
    const {id} = Route.useParams();
    return (
      <div className='bg-canvas-background'>
        <Chat id={id} />
        <title>Banani | Preview</title>
      </div>
    );
  },
});
